export default Object.freeze({
  UNSET: 0,
  STATUS_HISTORY: 1,
  APPROVE: 2,
  OBJECT: 3,
  CANCEL: 4,
  CONTRACT_HISTORY: 5,
  RETURN_TO_PREVIOUS_STATUS: 6,
  DOCUMENT: 7,
  MODIFY_APPROVAL_DATE: 8,
  BITACORA: 9,
  BITACORA_HISTORY: 10,
  REQUEST_RECONSIDERATION: 11,
});
